const NEW_TASK = 'sure-quote/tasks/task/NEW_TASK';
const TOGGLE_PROGRESS_OPEN = 'TOGGLE_PROGRESS_OPEN';
const OPEN_PROGRESS = 'OPEN_PROGRESS';
const CLOSE_PROGRESS = 'CLOSE_PROGRESS';
const REMOVE_TASK = 'REMOVE_TASK';
const ADD_PENDING_TASK = 'ADD_PENDING_TASK';
const INITIAL_FETCH = 'INITIAL_FETCH';

const defaultState = {
	progressOpen: false,
	currentTasks: [],
	pendingTasks: [],
	initialFetchDone: false
};

const handletoggleProgressOpen = (state, action) => {
	const progressOpen = !state.progressOpen;
	global.monkey = progressOpen;

	return {
		...state,
		progressOpen: progressOpen
	};
};

const handleOpenProgress = (state, action) => {
	global.monkey = true;

	return {
		...state,
		progressOpen: true
	};
};

const handleCloseProgress = (state, action) => {
	global.monkey = false;

	return {
		...state,
		progressOpen: false
	};
};

const handleAddPendingTask = (state, action) => {
	return {
		...state,
		pendingTasks: [...state.pendingTasks, action.props.task]
	};
};

const handleNewTask = (state, action) => {
	const currentTasks = action.props.props;
	let pendingTasks = state.pendingTasks;

	currentTasks.forEach(task => {
		pendingTasks = pendingTasks.filter(t => t.guid !== task.guid);
	});

	return {
		...state,
		currentTasks: action.props.props,
		pendingTasks: pendingTasks
	};
};

const handleRemoveTask = (state, action) => {
	const currentTasks = state.currentTasks.filter(
		t => t.guid !== action.props.guid
	);

	return {
		...state,
		currentTasks: currentTasks,
		progressOpen: true
	};
};

const handleInitalFetch = (state, action) => {
	if (state.initialFetchDone) return state;

	return {
		...state,
		currentTasks: action.props.tasks,
		initialFetchDone: true
	};
};

const TasksReducer = (state = defaultState, action) => {
	switch (action.type) {
		case ADD_PENDING_TASK:
			return handleAddPendingTask(state, action);
		case NEW_TASK:
			return handleNewTask(state, action);
		case TOGGLE_PROGRESS_OPEN:
			return handletoggleProgressOpen(state, action);
		case OPEN_PROGRESS:
			return handleOpenProgress(state, action);
		case CLOSE_PROGRESS:
			return handleCloseProgress(state, action);
		case REMOVE_TASK:
			return handleRemoveTask(state, action);
		case INITIAL_FETCH:
			return handleInitalFetch(state, action);
		default:
			return state;
	}
};

export const addPendingTask = props => ({ type: ADD_PENDING_TASK, props });
export const newTask = props => ({ type: NEW_TASK, props });
export const toggleProgressOpen = () => ({ type: TOGGLE_PROGRESS_OPEN });
export const openProgress = () => ({ type: OPEN_PROGRESS });
export const closeProgress = () => ({ type: CLOSE_PROGRESS });
export const removeTask = props => ({ type: REMOVE_TASK, props });
export const initialFetch = props => ({ type: INITIAL_FETCH, props });

export default TasksReducer;



// WEBPACK FOOTER //
// ./src/reducers/TasksReducer.js